export default {
    process: {
        label: "Production Progress",
        empty: "No production progress",
    },
};
